/**
 * FormSelect Component
 * 
 * Styled select field that integrates with FormField.
 * Can be used standalone or wrapped in FormField.
 */

import React, { forwardRef } from 'react';

export interface FormSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  /** Whether the select has an error */
  hasError?: boolean;
}

export const FormSelect = forwardRef<HTMLSelectElement, FormSelectProps>(
  ({ hasError, className = '', children, ...props }, ref) => {
    const baseClasses = 'w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 transition-colors';
    const stateClasses = hasError
      ? 'border-red-300 focus:ring-red-500 focus:border-red-500'
      : 'border-gray-300 focus:ring-blue-500 focus:border-blue-500';
    
    return (
      <select
        ref={ref}
        className={`${baseClasses} ${stateClasses} ${className}`}
        {...props}
      >
        {children}
      </select>
    );
  }
);

FormSelect.displayName = 'FormSelect';
